<script lang="ts">
  import type { ControlValidator, ValidatorMessages } from "../../forms/validators";
  import FormField from "../../forms/FormField.svelte";
  import { Control, setupControl } from "../../forms/controls";
  import { setContext } from "svelte";

  export let title: string;
  export let name: string;
  export let validators: ControlValidator[] = [];
  export let value: any[] = undefined;
  export let control: Control = null;
  export let standalone: boolean = false;
  export let displayName: string = undefined;
  export let errors: ValidatorMessages = undefined;

  const changes = setupControl(Control, {
    name,
    validators,
    value: value || [],
    control,
    standalone,
  });
  setContext("ToggleButtons", changes);
  $: ctrl = $changes;

  let oldValue = value;
  $: if (value !== oldValue) {
    oldValue = value;
    ctrl.value = value;
  }
</script>

<FormField control={ctrl} {displayName} {errors} {standalone} on:change>
  <div class="toggle-buttons">
    <div class="title">{title}</div>
    <div class="toggle-buttons-content">
      <slot value={Array.isArray(ctrl.value) ? ctrl.value : []} />
    </div>
  </div>
</FormField>

<style lang="scss">
  .toggle-buttons {
    .title {
      font-size: 1rem;
      font-weight: bold;
      padding: 0 1rem;
      margin-bottom: 0.4em;
    }
  }

  .toggle-buttons-content {
    position: relative;
    display: grid;
    // grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    border: solid 2px #d9d9d9;
    border-radius: 20px;
    overflow: hidden;

    :global(.toggle-button) {
      border-top: 2px solid transparent !important;
      border-left: 2px solid transparent !important;
      border-bottom: 2px solid #d9d9d9;
      border-right: 2px solid #d9d9d9;
      margin-right: -2px;
      margin-bottom: -2px;
    }
  }
</style>
